// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PSearchOutlinedSvg from "@fishx/icons-svg/es/asn/PSearchOutlined";
import FishxIcon from '../components/FishxIcon';

var PSearchOutlined = function PSearchOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PSearchOutlinedSvg
  }));
};

PSearchOutlined.displayName = 'PSearchOutlined';
export default React.forwardRef(PSearchOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PSearchOutlined.js
// module id = 3622
// module chunks = 0